export default {
  namespaced: true,
  state: {
    position: {
      longitude: '',
      latitude: ''
    }
  },
  getters: {
    getPosition: state => {
      return state.position;
    }
  },
  mutations: {
    setPosition (state, position) {
      state.position = JSON.parse(position)
    }
  },
  actions: {
    initialPosition ({commit}) {
      window.getNativeLocation()
      window.getPosition = function(position) {
        // toast(position)
        commit('setPosition', position)
      }
    },
    refreshPosition({commit}) {
      window.startLocateSilently();
      window.getPosition = function (position) {
        commit('setPosition', position)
      }
    }
  }
}
